import i18n from '@/i18n'

export default {
  mitigationHabitatHeaders () {
    return [
      {
        sortable: true,
        text: i18n.t('habitatName'),
        value: 'name',
        width: '25%'
      },
      {
        sortable: false,
        text: i18n.t('habitatDescription'),
        value: 'description',
        width: '35%'
      },
      {
        sortable: false,
        text: i18n.t('mitigationSteps'),
        value: 'mitigationSteps',
        width: '35%'
      },
      {
        sortable: false,
        text: i18n.t('related'),
        value: 'related',
        align: 'center'
      },
      {
        sortable: false,
        text: i18n.t('actions'),
        value: 'actions',
        align: 'center'
      }
    ]
  },

  dueDiligenceExemptionHeaders () {
    return [
      {
        sortable: true,
        text: i18n.t('exemptionName'),
        value: 'name',
        width: '25%'
      },
      {
        sortable: false,
        text: i18n.t('description'),
        value: 'description',
        width: '40%'
      },
      {
        sortable: false,
        text: i18n.t('options'),
        value: 'options',
        width: '25%'
      },
      {
        sortable: false,
        text: i18n.t('actions'),
        value: 'actions',
        align: 'center'
      }
    ]
  }
}
